import { site } from "../content";
import { Icon } from "./Icon";
import { WaCta } from "./WaCta";
import { Reveal, SectionHeading } from "./Reveal";

export default function Shipping() {
  return (
    <section id="entrega" data-testid="shipping-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading
          chapter="14"
          eyebrow="Entrega"
          title="Barber Steamer na sua barbearia."
          align="center"
          testId="shipping-heading"
        />

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {site.shipping.items.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.08}>
              <div
                data-testid={`shipping-card-${i}`}
                className="h-full rounded-2xl border border-white/10 bg-graphite/60 p-8 text-center backdrop-blur-xl"
              >
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl border border-gold/25 bg-gold/[0.07] text-gold">
                  <Icon name={item.icon} className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-display text-sm font-extrabold uppercase tracking-[0.15em] text-bone">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-bone/55">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col items-center gap-6">
            <WaCta
              message={site.messages.shipping}
              location="shipping"
              label="Consultar entrega para minha cidade"
              testId="shipping-cta"
            />
            <p className="max-w-xl text-center text-xs leading-relaxed text-bone/40" data-testid="shipping-disclaimer">
              {site.shipping.disclaimer}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
